import { HTMLELEMENT } from '../../../EL/EL.js';
// import TABLE, { TableElementModel } from '@model/EL/table/TABLE.js';
import TGROUP from '../../../DOM/table/TGROUP/TGROUP.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const tbodyAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const tbodyData = makeDataStruct([]);
export const tbodyModel = makeStruct([
    ['attributes', tbodyAttr],
    ['data', tbodyData]
]);
// Simplified Model
export function tbody(name, className) {
    return {
        attributes: tbodyAttr(name, className),
        data: tbodyData()
    };
}
/** A TABLE Body Grouping */
export default class TBODY extends TGROUP {
    // declare public node: TABLE<TableElementModel>;
    // constructor(node: TABLE<TableElementModel>, model: M) {
    constructor(node, model) {
        super(node, HTMLELEMENT.TBODY, model);
        this.addClass('table-body');
    }
}
